import { render, staticRenderFns } from "./ClaseComprobante.vue?vue&type=template&id=cc78b380&"
import script from "./ClaseComprobante.vue?vue&type=script&lang=js&"
export * from "./ClaseComprobante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports